// Helpers per URL localizzate: italiano senza prefisso, altre lingue con /xx/
import { SUPPORTED_LANGUAGES } from "./index";

export const DEFAULT_LANGUAGE = "it";
export const LANG_PREFIXES = SUPPORTED_LANGUAGES.map((l) => l.code).filter(
  (c) => c !== DEFAULT_LANGUAGE
);
export const ALL_LANGUAGES = SUPPORTED_LANGUAGES.map((l) => l.code);
export const LANG_PREF_KEY = "arabell_lang_pref";
export const SITE_BASE = "https://arabellgroup.com";

// Percorsi privati/applicativi che non vanno localizzati né indicizzati
const PRIVATE_PREFIXES = [
  "/admin",
  "/arabell-staff",
  "/arabell-member",
  "/staff-offerta",
  "/staff-contratto",
  "/sales-contract-print",
  "/verify",
];

export const isPublicPath = (path) =>
  !PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));

// "/en/supercar-luxury" -> { lang: "en", path: "/supercar-luxury" }
export const splitLangPath = (pathname) => {
  const seg = pathname.split("/")[1];
  if (LANG_PREFIXES.includes(seg)) {
    const rest = pathname.slice(seg.length + 1) || "/";
    return { lang: seg, path: rest.startsWith("/") ? rest : `/${rest}` };
  }
  return { lang: null, path: pathname || "/" };
};

// ("/supercar-luxury", "de") -> "/de/supercar-luxury"
export const withLang = (path, lang) => {
  const clean = path === "/" ? "" : path;
  if (!lang || lang === DEFAULT_LANGUAGE) return clean || "/";
  return `/${lang}${clean}`;
};

export const absoluteUrl = (path, lang) => `${SITE_BASE}${withLang(path, lang)}`;

export const OG_LOCALES = {
  it: "it_IT",
  en: "en_GB",
  fr: "fr_FR",
  es: "es_ES",
  de: "de_DE",
  ar: "ar_AE",
};

const BOT_RE =
  /bot|crawl|spider|slurp|bingpreview|googlebot|duckduckbot|baiduspider|yandex|facebookexternalhit|embedly|quora|pinterest|whatsapp|telegrambot|lighthouse|headlesschrome/i;

export const isBotAgent = () =>
  typeof navigator !== "undefined" && BOT_RE.test(navigator.userAgent || "");
